export default (props) => (
  /**
   * Configuração/ativação dos rótulos com
   * preenchimento de cor dinâmica.
   * Responsavel por exibir rótulo da camada
   * importada se a mesma possuir rótulo.
   */
  <svg
    width="27"
    height="18"
    viewBox="0 0 27 18"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
    fill="none"
  >
    <g clipPath="url(#clip0_3194_9522)">
      <path
        d="M14.3642 5.23438V13.1521H12.7988V9.9322H11.2202V13.1521H9.65479V5.23438H14.3642ZM12.7988 8.37505V6.80471H11.2202V8.37505H12.7988Z"
        fill={props.fill ? props.fill : 'currentColor'}
      />
      <path
        d="M20.4155 5.23438V13.1521H15.7192V5.23438H20.4155ZM18.8632 8.37505V6.80471H17.2847V8.37505H18.8632ZM17.2847 9.9322V11.5025H18.8632V9.9322H17.2847Z"
        fill={props.fill ? props.fill : 'currentColor'}
      />
      <path
        d="M26.48 5.23438V6.80471H23.336V11.5025H26.48V13.1521H21.7837V5.23438H26.48Z"
        fill={props.fill ? props.fill : 'currentColor'}
      />
    </g>
    <path
      d="M10.952 2.26953L2.46582 4.05182L9.88462 15.9951"
      stroke={props.fill ? props.fill : 'currentColor'}
    />
    <circle
      cx="10.9195"
      cy="2.26949"
      r="1.5"
      transform="rotate(-171.594 10.9195 2.26949)"
      fill={props.fill ? props.fill : 'currentColor'}
    />
    <circle
      cx="2.46587"
      cy="4.0234"
      r="1.5"
      transform="rotate(-171.594 2.46587 4.0234)"
      fill={props.fill ? props.fill : 'currentColor'}
    />
    <circle
      cx="9.86577"
      cy="15.9961"
      r="1.5"
      transform="rotate(-171.594 9.86577 15.9961)"
      fill={props.fill ? props.fill : 'currentColor'}
    />
    <circle
      cx="9.86575"
      cy="15.9961"
      r="0.75"
      transform="rotate(-171.594 9.86575 15.9961)"
      fill={props.fill ? props.fill : 'currentColor'}
    />
    <defs>
      <clipPath id="clip0_3194_9522">
        <rect
          width="16.8251"
          height="7.85169"
          fill="white"
          transform="translate(9.65479 5.23438)"
        />
      </clipPath>
    </defs>
  </svg>
);
